import React from "react";
import { useHistory } from "react-router-dom";

import { DialogModal } from "../../_common/DialogModal/DialogModal";
import MerchantConfigContext from "../../App/MerchantConfigContext";
import {
  getModifyOrderLocationRoute,
  getOrderStoreAddressForDialogModal,
} from "../../_common/PaymentHelpers";

export const OrderDetailsConfirmationDialog = ({
  activeOrderStore,
  appLabels,
  orderTimeContext,
  skin,
  deliveryAddress,
  confirmAction,
  closeModalAction,
}) => {
  const history = useHistory();
  const merchantConfig = React.useContext(MerchantConfigContext);
  const isStadiumSchema = merchantConfig.merchant.I55 === "stadium";

  return (
    <DialogModal
      message={getOrderStoreAddressForDialogModal(
        activeOrderStore,
        appLabels,
        null,
        orderTimeContext.value.displayValue,
        "delivery",
        orderTimeContext,
        skin,
        deliveryAddress
      )}
      isConfirmText={true}
      isModifyText={appLabels["order"]["modify-location"]}
      isCancelConfirm={true}
      confirmAction={confirmAction}
      resetRemoveDialog={() =>
        history.push(getModifyOrderLocationRoute(isStadiumSchema, "delivery"))
      }
      closeModalAction={closeModalAction}
    />
  );
};
